export default __webpack_public_path__ + "media/ai-tools.c074de57.webp";